import EfiPay from "payment-token-efi";

// Enum para identificar bandeiras de cartão
export enum EBrand {
  VISA = "visa",
  MASTER = "mastercard",
  AMERICANEXPRESS = "amex", // Verifique se esse nome está correto na API
  ELO = "elo",
  HIPERCARD = "hipercard",
  UNDEFINED = "undefined",
  UNSUPPORTED = "unsupported",
}

// Interface para parcelamento
interface IListInstallments {
  brand: EBrand;
  total: number;
}

// Interface para gerar token de pagamento
export interface IGeneratePaymentToken {
  brand: EBrand;
  number: string;
  cvv: string;
  expirationMonth: string;
  expirationYear: string;
  holderName: string;
  holderDocument: string;
  reuse: boolean; // Agora é sempre booleano
}

// Interface para resposta do token de pagamento
interface IGeneratePaymentTokenResponse {
  payment_token: string;
  card_mask: string;
}

interface IGeneratePaymentTokenError {
  code: string;
  error: string;
  error_description: string;
}

export interface IPaymentCardLicitem {
  planId: string;
  supplierId: string;
  paymentToken: string;
  reuseCard: boolean;
  customerName: string;
  customerCpf: string;
  cardMask: string;
  onDemandProcessCount?: number;
}


// Identificador da conta
const identifyAccount = process.env.REACT_APP_EFI_IDENTIFY_ACCOUNT ?? "";
const environment = process.env.REACT_APP_EFI_ENVIRONMENT === "production" ? "production" : "sandbox";

function handleError(error: any): null {
  console.error("Erro na requisição:");
  console.error("Código:", error?.code || "Desconhecido");
  console.error("Nome:", error?.error || "Desconhecido");
  console.error("Mensagem:", error?.error_description || "Sem detalhes");
  return null;
}

// Identificar a bandeira do cartão
export async function identifyBrand(cardNumber: string): Promise<any> {
  try {
    const response = await EfiPay.CreditCard.setCardNumber(cardNumber).verifyCardBrand();
    return response;
  } catch (error) {
    return handleError(error);
  }
}

// Buscar informações de parcelamento
export async function listInstallments({ brand, total }: IListInstallments): Promise<any> {
  try {
    const installments = await EfiPay.CreditCard
      .setAccount(identifyAccount)
      .setEnvironment(environment)
      .setBrand(brand)
      .setTotal(total)
      .getInstallments();

    return installments;
  } catch (error) {
    return handleError(error);
  }
}

// Gerar token de pagamento
export async function generatePaymentToken(data: IGeneratePaymentToken): Promise<IGeneratePaymentTokenResponse | any> {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await EfiPay.CreditCard
        .setAccount(identifyAccount)
        .setEnvironment(environment)
        .setCreditCardData({
          brand: data.brand,
          number: data.number,
          cvv: data.cvv,
          expirationMonth: data.expirationMonth,
          expirationYear: data.expirationYear,
          holderName: data.holderName,
          holderDocument: data.holderDocument,
          reuse: data.reuse,
        })
        .getPaymentToken();
  
      resolve(response as IGeneratePaymentTokenResponse);
    } catch (error) {
      const err = error as IGeneratePaymentTokenError;
      return reject(err.error_description);
    }
  });
}
